import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('prevenda', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async findDetalhado(_, { idVendedor, food, status }) {
      const params = status ? { status } : undefined;
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`prevenda/detalhado/${idVendedor}/${food}`, { params }),
      ]);

      return data;
    },

    async listarMesas(_, { idVendedor, food }) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`prevenda/mesas/${idVendedor}/${food}`),
      ]);

      return data;
    },

    async create(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('prevenda/app', body),
      ]);

      return data;
    },

    async update(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put(`prevenda/app/${body.id}`, body),
      ]);

      return data;
    },

    async delete(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.delete(`prevenda/app/${body.id}`, body),
      ]);

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
